import { ICellRendererParams } from '@ag-grid-enterprise/all-modules';
import { format } from 'date-fns';
import React from 'react';

import { CONSTANTS } from '../../../../core/config/constants';

interface Props extends ICellRendererParams {
  dateFormat?: string;
}

const DateCellRenderer: React.FC<Props> = (props) => {
  return (
    <>
      {props.value
        ? format(new Date(props.value), props.dateFormat ?? CONSTANTS.DATE_FORMATS.DATE_TIME)
        : null}
    </>
  );
};

export default DateCellRenderer;
